const stopPropagation = (e) => {
    e.stopPropagation();
}

export default stopPropagation;


// WEBPACK FOOTER //
// ./src/utilities/stopPropagation.js